<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      agentList: 'agents/getAgents',
    }),
  },
  validations: {
    channelName: { required },
  },
  mounted() {
    this.$store.dispatch('agents/get');
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName?.trim(),
          internal_chat: true,
          channel: {
            type: 'internal_chat',
          },
        });

        router.replace({
          name: 'settings_inbox_finish',
          params: {
            page: 'new',
            inbox_id: inbox.id,
          },
        });
      } catch (error) {
        useAlert(
          this.$t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.DESC')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model="channelName"
            type="text"
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.CHANNEL_NAME.PLACEHOLDER'
              )
            "
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.AGENTS.LABEL') }}
        </label>
        <p class="help-text mt-1">
          {{
            $t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.AGENTS.HELP_TEXT', {
              count: agentList.length,
            })
          }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="
            $t('INBOX_MGMT.ADD.INTERNAL_CHAT_CHANNEL.SUBMIT_BUTTON')
          "
        />
      </div>
    </form>
  </div>
</template>
